import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const RightArrowIcon = ({ color = 'var(--brand-bg-primary)', ...props }: IconProps) => {
  return (
    (<svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      data-palette="RightArrowIcon">
      <path
        d="M3.68367 4L0.796173 6.8875L1.62101 7.71233L5.33334 4L1.62101 0.287666L0.796173 1.1125L3.68367 4Z"
        fill={color}
      />
    </svg>)
  );
};

export default RightArrowIcon;
